<app-auth-pages>
    <ng-container *transloco="let t;">
        @if (passwordChangeRequested === false) {
        <h2 class="card-title fw-bold mb-1">
            {{ t('Forgot password title (Forgot password page) - Reset your password')
            }}
        </h2>
        <p class="card-text mb-2">{{ t('Forgot password description (Forgot password page) - Recover Password By Typing
            Email') }}.</p>
        <ngb-alert [type]="'danger'" [dismissible]="false" *ngIf="error">
            <div class="alert-body">
                <p>{{ error }}</p>
            </div>
        </ngb-alert>

        <form class="auth-register-form mt-2" autocomplete="off" [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="form-group">
                <label for="email" class="form-label fw-bold">{{ t('Email (general) - Email') }}</label>
                <input id="email" type="text" formControlName="email" class="form-control"
                    placeholder="john@example.com" aria-describedby="register-email" tabindex="2"
                    [ngClass]="{ 'is-invalid': submitted && form.get('email').invalid }" />
                <div *ngIf="submitted && form.get('email').invalid" class="invalid-feedback">
                    <div *ngIf="form.get('email').hasError('required')">
                        {{ t('Field required (form validation) - Field name is required', {fieldName: t('Email (general)
                        - Email')}) }}
                    </div>
                    <div *ngIf="form.get('email').hasError('email')">{{
                        t('Email validation (form validation) - Email must be a valid email address')
                        }}
                    </div>
                </div>
            </div>

            <button [disabled]="loading" class="btn btn-primary btn-block" tabindex="4" rippleEffect>
                <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>{{ t('Recover button text
                (Forgot password page) - Recover') }}
            </button>
        </form>

        } @else {

        <h2 class="card-title fw-bold mb-1">
            {{ t('email sent title (Forgot password page) - Email sent')
            }}
        </h2>
        <p class="card-text mb-2">{{ t('Send email notification text (Forgot password page) - We sent you an email for
            updating your password') }}.</p>
        <div class="text-center">
            <a href="#/login" class="back-to-login-text">{{ t('back to login text (Forgot password page) - Back to
                login')
                }}</a>
        </div>
        }
    </ng-container>
</app-auth-pages>